import { render, staticRenderFns } from "./ModalForgotPassword.vue?vue&type=template&id=46c3e74e&"
import script from "./ModalForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ModalForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c3e74e')) {
      api.createRecord('46c3e74e', component.options)
    } else {
      api.reload('46c3e74e', component.options)
    }
    module.hot.accept("./ModalForgotPassword.vue?vue&type=template&id=46c3e74e&", function () {
      api.rerender('46c3e74e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Login/Modal/ModalForgotPassword.vue"
export default component.exports